import {
  REQUEST_SET_CAR_BOOKMARK,
  RESPONSE_SET_CAR_BOOKMARK,
  REQUEST_SET_CAR_BOOKMARK_FAILURE
} from './../actions/setCarBookmarkActions'

import { states as queriesStates } from './queriesStates'

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  errors: [],
}

const setCarBookmarkReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SET_CAR_BOOKMARK:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.REQUEST
        }
      )
    case RESPONSE_SET_CAR_BOOKMARK:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.READY
        }
      )
    case REQUEST_SET_CAR_BOOKMARK_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.FAILURE,
          errors: action.errors
        }
      )
    default:
      return state
  }
}

export default setCarBookmarkReducer